// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"40ec7b15","453":"94315750"}[chunkId] + ".chunk.js";
};